import React from 'react';
import {getLastResortErrorMessage} from "./lastResortErrorMessage";
import {Button, Icon} from "antd";
import {navigateToHome} from "../navigation/navigationHistory";

export class ErrorScope extends React.Component {

  static defaultProps = {
    reloadable: true
  };

  state = {...NO_ERROR_STATE};

  dropError = () => {
    this.setState(NO_ERROR_STATE);
  };

  render() {
    const {reloadable, children} = this.props;
    if (this.state.hasError) {
      return <ErrorPage message={this.state.errorMessage} reloadable onReload={this.dropError}/>;
    }
    return children;
  }

  componentDidCatch(error) {
    let errorMessage;
    try {
      errorMessage = this.props.errorMessage || getLastResortErrorMessage();
    } catch (e) {
      console.error(e);
      errorMessage = 'server unavailable';
    }
    this.setState({hasError: true, errorMessage});
    console.error(error);
  }
}

const NO_ERROR_STATE = {
  hasError: false,
  errorMessage: ''
};

export function ErrorPage({message, reloadable, onReload}) {
  return <span>
    {message}{' '}
    {reloadable ? <Button id="redo-button" shape="circle" onClick={onReload}>
      <Icon type='redo'/>
    </Button> : <Button id="home-button" shape="circle" onClick={() => navigateToHome()}>
      <Icon type='home'/>
    </Button>}
  </span>;
}